import React from "react";
import "./Header.css";
class Header extends React.Component {
	componentDidMount() {
		window.addEventListener("scroll", this.handleScroll);
		setTimeout(() => {
			let h1 = document.querySelector(".header h1");
			let h2 = document.querySelector(".header h2");
			h1.style = `visibility:visible;opacity:1;`;
			h2.style = `visibility:visible;opacity:1;`;
		}, 500);
	}
	render() {
		return (
			<div className='headerOnef'>
				<img
					loading='lazy'
					style={{
						width: "100vw",

						display: "block",
					}}
					className='hero'
					src='/img/mov/hero3.png'
					alt='Hero'
				/>
				<h1>Motorschirm Rundflug</h1>
				<h2>Buche dir jetzt deinen Rundflug</h2>
			</div>
		);
	}
}

export default Header;
